import BaseApi from './BaseApi';
/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        timeout: 60000
    });

    const sendForSigningTask = (ticketId) => {
        let url = `preparereturnvir/${ticketId}/sendforsigning`
        return api.put(url, null);
    }

    const sendForResettingDocuments = (ticketId) => {
        let url = `preparereturnvir/${ticketId}/sendforresettingdocuments`
        return api.put(url, null);
    }   

    const sendForReadyToFilePaymentTask = (ticketId) => {
        let url = `preparereturnvir/${ticketId}/readytofile`
        return api.put(url, null);
    }

    const sendForCompleteReturnTask = (ticketId) => {
        let url = `preparereturnvir/${ticketId}/completereturn`
        return api.put(url, null);
    }

    // Return back a collection of functions
    return {
        sendForSigningTask, sendForReadyToFilePaymentTask, sendForCompleteReturnTask, sendForResettingDocuments
    }
}

// let's return back our create method as the default.
export default {
    create
}
